"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transformStyleName;

var changeCase = _interopRequireWildcard(require("change-case"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function transformStyleName(styleName) {
  if (styleName.startsWith('--')) {
    // CSS variable declaration: https://developer.mozilla.org/en-US/docs/Web/CSS/--*
    return styleName;
  }

  var cssName = changeCase.paramCase(styleName);

  if (cssName.startsWith('webkit')) {
    // We allow `webkitLineClamp` in our generated types (`AllCSSPropertyTypes`) which seems to be
    // the only one user might write manually, see: https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp
    cssName = "-".concat(cssName);
  }

  return cssName;
}